import LoadScript from "../utils/LoadScript";
export default class BlockMovie {

	static init() {

		this.playerYoutube = document.querySelectorAll('.player-youtube');
		this.playerVimeo = document.querySelectorAll('.player-vimeo');

		if( this.playerYoutube.length > 0 ){
			if( window.YT && window.YT.Player ) {
				this.initPlayerYoutube();
			} else {
				window.onYouTubeIframeAPIReady = this.initPlayerYoutube.bind(this);
				LoadScript.load( 'https://www.youtube.com/iframe_api', () => {} );
			}
		}

		if( this.playerVimeo.length > 0 ){
			LoadScript.load( 'https://player.vimeo.com/api/player.js', this.initPlayerVimeo.bind(this) );
		}

	}

	static initPlayerYoutube(){

		this.playerYoutube.forEach( (youtube) => {

			let el = youtube;
			let videoID = el.dataset.videoId;
			let player = el.closest('.movie, .banner-movie');
			let isBanner = player.classList.contains('banner-movie');

			if( isBanner ){

				new YT.Player(videoID, {
					videoId: videoID,
					playerVars: {
						'autoplay': 1,
						'mute': 1,
						'loop': 1,
						'playlist': videoID,
						'controls': 0,
						'showinfo': 0,
						'modestbranding': 1,
						'rel': 0,
						'enablejsapi': 1
					},
					events: {
						'onReady': (event) => {
							player.classList.add('player-load');
							event.target.playVideo();
						},
						'onStateChange': (event) => {
							if( event.data === 1 ){
								player.classList.add('playing');
							}
						}
					}
				});

			} else {

				if( !player.querySelector('img') ) {
					let poster = "https://img.youtube.com/vi/" + videoID + "/hqdefault.jpg";
					let img = document.createElement('img');
					img.src = poster;
					player.append(img);
				}

				let youtubePlayer = null;
				player.addEventListener('click', () => {
					if ( !player.classList.contains('player-load') ) {
						youtubePlayer = new YT.Player(videoID, {
							height: '360',
							width: '640',
							videoId: videoID,
							playerVars: {
								'autoplay': 0,
								'controls': 0,
								'showinfo': 0,
								'modestbranding': 1,
								'rel': 0,
								'iv_load_policy': 3,
								'enablejsapi': 1
							},
							events: {
								'onStateChange': (event) => {
									if( event.data === 1 ){
										player.classList.add('playing');
									}
								},
								'onReady': (event) => {
									player.classList.add('player-load');
									event.target.playVideo();
								}
							}
						});
					} else {
						youtubePlayer.playVideo();
					}
				});

			}

		});

	}

	static initPlayerVimeo(){

		this.playerVimeo.forEach( (vimeo) => {

			let el = vimeo;
			let videoID = el.dataset.videoId;
			let url = el.dataset.videoUrl;
			let player = el.closest('.movie, .banner-movie');
			let isBanner = player.classList.contains('banner-movie');

			if( isBanner ){

				// background: true = autoplay + muted + loop + no controls
				let playerVimeo = new Vimeo.Player(el, { id: videoID, background: true });
				playerVimeo.on('play', () => {
					player.classList.add('player-load', 'playing');
				});

			} else {

				if( !player.querySelector('img') ) {
					const xhttp = new XMLHttpRequest();
					xhttp.onload = function () {
						let poster = xhttp.response.thumbnail_url;
						let img = document.createElement('img');
						img.src = poster;
						player.append(img);
					};
					xhttp.responseType = 'json';
					xhttp.open("GET", 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url), true);
					xhttp.send();
				}

				let playerVimeo = new Vimeo.Player(videoID, { id : videoID });

				playerVimeo.on("pause", () => {
					player.classList.remove('playing');
				});

				playerVimeo.on("play", () => {
					player.classList.add('playing');
				});

				player.addEventListener('click', () => {
					if ( !player.classList.contains('player-load') ) {
						player.classList.add('player-load');
					}
					playerVimeo.play();
				});

			}

		});

	}

}
